import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-100 text-slate-600 py-8 md:py-12 border-t border-slate-200" data-id="element-131">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-132">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-8 pb-8 border-b border-slate-200" data-id="element-133">
          <div className="text-center md:text-left" data-id="element-134">
            <div className="text-navy font-bold text-xl mb-2 flex items-center justify-center md:justify-start gap-2" data-id="element-135">
              🎓 MEGAPACK LECTURA FLUIDA
            </div>
            <p className="text-sm max-w-sm" data-id="element-136">
              El sistema para padres que quieren acompañar la lectura de sus
              hijos en Argentina. Sin silabeo, sin peleas, con confianza real.
            </p>
          </div>

          <div className="flex flex-col gap-3 text-sm" data-id="element-137">
            <a href="mailto:soportetupuntodigital@gmail.com" className="flex items-center hover:text-navy transition-colors" data-id="element-138">
              <Mail className="w-4 h-4 mr-3" data-id="element-139" /> soportetupuntodigital@gmail.com
            </a>
            <a href="https://www.instagram.com/tu_punto_digitall" target="_blank" rel="noopener noreferrer" aria-label="Instagram @tu_punto_digitall" className="flex items-center hover:text-navy transition-colors" data-id="element-140">
              <Instagram className="w-4 h-4 mr-3" data-id="element-141" /> @tu_punto_digitall
            </a>
            <a href="https://www.tupuntodigital.shop" target="_blank" rel="noopener noreferrer" aria-label="Sitio web Tu Punto Digital" className="flex items-center hover:text-navy transition-colors" data-id="element-142">
              <Globe className="w-4 h-4 mr-3" data-id="element-143" /> www.tupuntodigital.shop
            </a>
          </div>
        </div>

        <div className="text-center text-xs text-slate-500" data-id="element-144">
          <p data-id="element-145">
            © MegaPack Lectura Fluida 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}